import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'tr[fu-list-view]',
	templateUrl: './fu-list-view.component.html',
	styleUrls: ['./fu-list-view.component.scss']
})
export class FileUploadListViewComponent {
	@Input() fileData;
	@Input() allowedDimensions;
	@Input() isPopup;
	@Output() output = new EventEmitter();
	showToolbar;

	constructor() {}

	deleteFile(fileName) {
		this.output.emit({ method: 'delete', fileName: fileName });
	}

	editFile(file) {
		this.output.emit({ method: 'edit', file: file });
	}

	disabled() {
		if (
			this.isPopup &&
			this.fileData.fileType === 'image' &&
			this.allowedDimensions &&
			this.allowedDimensions !== this.fileData.dimensions[0] + 'x' + this.fileData.dimensions[1]
		) {
			return true;
		} else {
			return false;
		}
	}

	selectFile() {
		if (!this.disabled()) {
			this.output.emit({ method: 'selected', fileName: this.fileData.oldPath });
		} else if (this.fileData.fileType === 'image') {
			this.output.emit({ method: 'edit', file: this.fileData });
		}
	}
}
